import { Injectable } from '@angular/core';

@Injectable()
export class DetectedCoreHostService {
  host: string = window.location.hostname;

  constructor() {
  }

  public setHost(): void {
    localStorage.setItem('host', this.host);
  }

  public getHost(): string {
    return localStorage.getItem('host');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/detected.core.host.service.ts